export const dataHeader = ["All", "Events", "Appointments", "Greetings"];

export const allMonth = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const monthNavbar = [
  { month: 0, value: "JAN" },
  { month: 1, value: "FEB" },
  { month: 2, value: "MAR" },
  { month: 3, value: "APR" },
  { month: 4, value: "MAY" },
  { month: 5, value: "JUN" },
  { month: 6, value: "JUL" },
  { month: 7, value: "AUG" },
  { month: 8, value: "SEP" },
  { month: 9, value: "OCT" },
  { month: 10, value: "NOV" },
  { month: 11, value: "DEC" },
];

export const reminderBodyData = [
  {
    label: "Starts",
    value: "",
  },
  {
    label: "Ends",
    value: "",
  },
  {
    label: "Remind Every",
    value: "Day(s)",
  },
  {
    label: "Remind When",
    value: "",
  },
];

export const reminderFooterData = [
  {
    label: "Description",
    value: "Things to discuss, event details, etc…",
  },
  {
    label: "Invite Members",
    value: "Add email to invite others",
  },
];
